import React from "react";
import BreadCrumb from "../BreadCrumb";
import Left from "./Advertise/Left";
import Right from "./Advertise/Right";
import BackButton from "../BackButton";

const Advertise = ({ ssr, isAppWebView }) => {
  return (
    <>
      <BreadCrumb title={ssr.result.baslik}></BreadCrumb>
      <div className="container">
        <div className="flex lg:flex-row flex-col my-10">
          <BackButton isAppWebView={isAppWebView} top="-top-12" left="left-0" />
          <Left />
          <Right isAppWebView={isAppWebView} />
        </div>
      </div>
    </>
  );
};

export default Advertise;
